import { useState, useEffect } from 'react';
import { FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import './SampleFilter.css';
import { useDispatch, useSelector } from 'react-redux';
import FieldNames from '../../../defaults/FieldNames.json';

const BlueAlien = "#1976d2";

export default function FiscalQuarterFilter({filter, selectionItem, setValue, value}) {

  const dispatch = useDispatch();
  const [filterValues, setFilterValues] = useState([]);
  
  const actionCategoryAssociations = useSelector((state) => state.globalContext.actionCategoryAssociations);


  const treatmentCategoryGroupings = actionCategoryAssociations ? actionCategoryAssociations[FieldNames.entityTypes.treatment]?.[FieldNames.categoryAssociationFields.categories] : [];

  useEffect(() => {
    let tempArray = [];
    ["Q1", "Q2", "Q3", "Q4"].forEach(element => {
      let isChecked = false;
      if (value && value.includes(element)) {
        isChecked = true;
      }
      var newItem = {
        name: element,
        code: element,
        isChecked: isChecked
      }
      tempArray.push(newItem);
    });
    setFilterValues(tempArray);
  }, [filter, value]);

  const checkboxChanged = (event, val) => {

    if (event.target.checked) 
    {
      let clone = [];
      if(value){
        clone = [...value];
      } 
      clone.push(val.code);
      dispatch(setValue(clone));
    }
    else 
    {
      if (value && val && value.includes(val.code)) 
      {
        const clone = [...value];
        clone.splice(clone.indexOf(val.code), 1);
        dispatch(setValue(clone));
      }
    }
  }

  //TODO: Rework this.
  const filterCheckboxes = (val, i, selection) => {
    if (selection !== "") {
      let itemsForFiltering = [];
      treatmentCategoryGroupings.forEach((grouping) => {
        if(selection === grouping.category){
          itemsForFiltering = grouping.types;
        }
      })

      if (itemsForFiltering && itemsForFiltering.length !== 0) {
        if (itemsForFiltering.includes(val.code)) {
          return (
            <FormControlLabel style={{ margin: '2px 10px 2px 0' }} key={i}
              control={
                <Checkbox style={{ padding: '0', margin: '0 5px 0 0px', borderColor: BlueAlien }} id={val.code} checked={val.isChecked} onClick={(e) => checkboxChanged(e, val)} />
              } label={val.name} />
          )
        } else {
          return;
        }
      } else {
        return (
          <FormControlLabel style={{ margin: '2px 10px 2px 0' }} key={i}
            control={
              <Checkbox style={{ padding: '0', margin: '0 5px 0 0px', borderColor: BlueAlien }} id={val.code} checked={val.isChecked} onClick={(e) => checkboxChanged(e, val)} />
            } label={val.name} />
        )
      }
    } else {
      return (
        <FormControlLabel style={{ margin: '2px 10px 2px 0' }} key={i}
          control={
            <Checkbox style={{ padding: '0', margin: '0 5px 0 0px', borderColor: BlueAlien }} id={val.code} checked={val.isChecked} onClick={(e) => checkboxChanged(e, val)} />
          } label={val.name} />
      )
    }
  }

  return (
    <FormGroup style={{ padding: '10px 4px 10px 10px', flexDirection: 'row', display: 'flex', justifyContent: 'flex-start' }}>
      <label style={{ clear: 'both', display: 'block', width: '100%', padding: '2px 4px', color: 'rgba(0, 0, 0, 0.6)', fontFamily: '"Roboto","Helvetica","Arial",sans-serif'}}>Fiscal Quarter</label>
      {filterValues.map((val, i) => (
        filterCheckboxes(val, i, selectionItem)
      ))}
    </FormGroup>
  )
}
